import { render } from "./UsuarioSelect.vue?vue&type=template&id=08ea3e42"
import script from "./UsuarioSelect.vue?vue&type=script&lang=js"
export * from "./UsuarioSelect.vue?vue&type=script&lang=js"

import exportComponent from "C:\\hd\\git\\enuve\\app-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__